/**
 * padLeadingZeros adds 0's to the start of a number. It will convert that
 * number to a string
 * @param {number} num the number to be padded
 * @param {number} amount the amount of zeros to add
 * @returns
 */
export function padLeadingZeros(num, amount) {
    let s = num + '';
    for (let i = 0; i < amount; i++) {
        s = '0' + s;
    }
    return s;
}

/**
 *
 * @typedef {Object} humanReadableSize
 * @property {number} size
 * @property {String} unit
 */

/**
 *  Get human readable file sizes. Returns an object of size and the unit.
 * @param {number} bytes
 * @param {number} decimals
 * @param {boolean} IEC
 * @return {humanReadableSize}
 */
export function getHumanReadableSize(bytes, decimals = 2, IEC = false) {
    const constant = IEC ? 1024 : 1000;
    const units = IEC ? ['Bytes', 'KiB', 'MiB', 'GiB'] : ['Bytes', 'KB', 'MB', 'GB'];
    const dm = decimals < 0 ? 0 : decimals;
    const i = Math.floor(Math.log(bytes) / Math.log(constant));
    bytes = (bytes / Math.pow(constant, i)).toFixed(dm);

    return { size: bytes, unit: units[i] };
}
